module.exports = __webpack_public_path__ + "post-listing-block-2-overlay-1sqOOHO.png";